import { render, staticRenderFns } from "./BaseStatusBadge.vue?vue&type=template&id=74152058&functional=true"
import script from "./BaseStatusBadge.vue?vue&type=script&lang=js"
export * from "./BaseStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports